import React, { Component } from 'react'
import './App.css'
import Data from './Data'

class App extends Component {
  render() {
    return <Data />
  }
}

export default App
